module.exports = __webpack_public_path__ + "static/media/footer-facebook.56c7d5f8.svg";